import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import * as z from 'zod'

import { InputField } from '@/components/fields/input-field'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

type Props = {
  form: any
}

export const cancellationReasons = [
  { label: 'No reason provided', value: 'NO_REASON_PROVIDED' },
  { label: 'Duplicate appointment', value: 'DUPLICATE_APPOINTMENT' },
  {
    label: 'Appointment made by mistake',
    value: 'APPOINTMENT_MADE_BY_MISTAKE',
  },
  { label: 'Client not available', value: 'CLIENT_NOT_AVAILABLE' },
  { label: 'Host not available', value: 'HOST_NOT_AVAILABLE' },
  { label: 'Other reason', value: 'OTHER_REASON' },
]

export const cancellationReasonOptionEnum = z.enum([
  'NO_REASON_PROVIDED',
  'DUPLICATE_APPOINTMENT',
  'APPOINTMENT_MADE_BY_MISTAKE',
  'CLIENT_NOT_AVAILABLE',
  'OTHER_REASON',
])

export const CancellationReasonForm = ({ form }: Props) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const watchCancellationReasonOption = form.watch('cancellationReasonOption')

  return (
    <div>
      <div className="mb-2">
        <Label>{t('cancellation_reason')}</Label>
      </div>
      <Select
        name="cancellationReasonOption"
        open={open}
        onOpenChange={setOpen}
        value={watchCancellationReasonOption}
        defaultValue={'NO_REASON_PROVIDED'}
        onValueChange={(value) => {
          const foundReason = cancellationReasons.find(
            (reason) => reason.value === value,
          )
          if (foundReason) {
            if (foundReason.value === 'OTHER_REASON') {
              form.setValue('cancellationReason', '')
            } else {
              form.setValue('cancellationReason', foundReason.label)
            }
            form.setValue('cancellationReasonOption', foundReason.value)
          }
        }}
      >
        <SelectTrigger>
          <SelectValue />
        </SelectTrigger>

        <SelectContent className="max-h-[250px]">
          {cancellationReasons.map((reason) => (
            <SelectItem key={reason.value} value={reason.value}>
              {reason.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {watchCancellationReasonOption === 'OTHER_REASON' && (
        <InputField
          form={form}
          control={form.control}
          className="mt-4"
          name={'cancellationReason'}
          label={t('custom')}
        />
      )}
    </div>
  )
}
